// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__ymu+C","content":"styles_content__wBb+H"};